export default "__VITE_ASSET__DExpmHMw__"